import { polygon, polygonMumbai, base, baseGoerli } from 'wagmi/chains'
import { CoinbaseWalletConnector } from 'wagmi/connectors/coinbaseWallet'
const { REACT_APP_JSON_RPC_POLYGON } = process.env

export const coinbaseConnector = new CoinbaseWalletConnector({
  chains: [polygon, polygonMumbai, base, baseGoerli],
  options: {
    appName: 'Linkdrop App',
    jsonRpcUrl: REACT_APP_JSON_RPC_POLYGON as string,
    darkMode: true
  },
})
